import { FunctionComponent, useCallback } from 'react'

import styled, { css } from 'styled-components'

import config from '@config'
import { mobileCSS } from '@measures/responsive'
import useBlickPlusOnboardingTracking from '@hooks/useBlickPlusOnboardingTracking'
import Blink from '@components/Blink'
import SvgIcon from '@components/SvgIcon'

const {
  appLinks: { ios, android },
} = config

export const StyledStoreIcon = styled(SvgIcon)`
  ${({ iconName }) => css`
    height: ${iconName.includes('app-store') ? '53px' : '49px'};
  `}
`

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: flex;
    ${mobileCSS(css`
      flex-direction: row;
      justify-content: space-between;
    `)};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing8};
  `}
`

const StoreIcons: FunctionComponent = () => {
  const iosUrl = `${ios}?pt=374817&ct=blickplus-onsite-onboarding&mt=8`
  const androidUrl = `${android}&hl=de&gl=CH&referrer=utm_source%3Dblick.ch%26utm_campaign%3Dblickplus-onsite-onboarding`
  const { trackOnClick } = useBlickPlusOnboardingTracking()

  const handleIosClick = useCallback(
    () =>
      trackOnClick({
        buttonText: 'Available on the App Store',
        element: 'app_download',
        targetUrl: iosUrl,
      }),
    [trackOnClick, iosUrl],
  )

  const handleAndroidClick = useCallback(
    () =>
      trackOnClick({
        buttonText: 'Get it on Google play',
        element: 'app_download',
        targetUrl: androidUrl,
      }),
    [trackOnClick, androidUrl],
  )

  return (
    <StyledWrapper>
      <Blink href={iosUrl} target="blank" onClick={handleIosClick}>
        <StyledStoreIcon iconName={`app-store-badge-german`} size={170} />
      </Blink>
      <Blink href={androidUrl} target="blank" onClick={handleAndroidClick}>
        <StyledStoreIcon iconName={`google-play-badge-german`} size={170} />
      </Blink>
    </StyledWrapper>
  )
}

export default StoreIcons
